import { Circle, Fill, Stroke, Style } from 'ol/style'
import { MultiPoint } from 'ol/geom'

export default function defaultDrawStyle() {
  const blue = '#0098fd'
  const white = '#ffffff'
  const imageStyle = new Circle({
    radius: 5,
    fill: new Fill({
      color: blue
    }),
    stroke: new Stroke({
      color: white,
      width: 2
    })
  })

  return [
    new Style({
      image: imageStyle,
      stroke: new Stroke({
        color: white,
        width: 5
      })
    }),
    new Style({
      image: imageStyle,
      geometry: feature =>
        new MultiPoint(feature.getGeometry().getCoordinates())
    }),
    new Style({
      stroke: new Stroke({
        color: blue,
        width: 3
      }),
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.4)'
      })
    })
  ]
}
